import React from 'react';
import { Select as AntSelect } from 'antd';
import { Spin } from '../../spin/spin';
import { ChevronDown, Close, Check, Spinner } from '@nackle/origami-icons';

/**
 * A Select Component
 *
 * {@link https://ant.design/components/select#select-props }
 *
 * @module Select
 * @param {Object} props - the component props
 * @param {string} [props.size] - the size of the select
 * @param {boolean} [props.loading] - whether or not the select is showing the "loading" spinner
 * @param {React.ReactElement} - specify content to show when no result matches.
 * @param {boolean} [props.autoFocus] - whether or not the select gets focus by default
 * @returns {React.ReactElement} - the antd select
**/
const Select = ( { ...props } ) => {
    const { size, loading, notFoundContent } = props;
    switch ( size ) {
        case 'small':
            return (
                <AntSelect
                    removeIcon={ <Close /> }
                    notFoundContent={ loading ? <Spin size="small" spinning={ true } /> : notFoundContent }
                    suffixIcon={ loading ? <Spinner className="select-loading" /> : <ChevronDown /> }
                    allowClear={ props.mode === 'multiple' ? { clearIcon: <Close /> } : false }
                    menuItemSelectedIcon={ <Check /> }
                    loading={ loading }
                    { ...props }
                >
                </AntSelect>
            );
        case 'middle':
            return (
                <AntSelect
                    removeIcon={ <Close /> }
                    notFoundContent={ loading ? <Spin size="small" spinning={ true } /> : notFoundContent }
                    allowClear={ props.mode === 'multiple' ? { clearIcon: <Close /> } : false }
                    suffixIcon={ loading ? <Spinner className="select-loading" /> : <ChevronDown /> }
                    menuItemSelectedIcon={ <Check /> }
                    loading={ loading }
                    { ...props }
                >
                </AntSelect>
            );
        case 'large':
            return (
                <AntSelect
                    removeIcon={ <Close /> }
                    notFoundContent={ loading ? <Spin size="small" spinning={ true } /> : notFoundContent }
                    allowClear={ props.mode === 'multiple' ? { clearIcon: <Close /> } : false }
                    suffixIcon={ loading ? <Spinner className="select-loading" /> : <ChevronDown /> }
                    menuItemSelectedIcon={ <Check /> }
                    loading={ loading }
                    { ...props }
                >
                </AntSelect>
            );
        default:
            return (
                <AntSelect
                    removeIcon={ <Close /> }
                    notFoundContent={ loading ? <Spin size="small" spinning={ true } /> : notFoundContent }
                    allowClear={ props.mode === 'multiple' ? { clearIcon: <Close /> } : false }
                    suffixIcon={ loading ? <Spinner className="select-loading" /> : <ChevronDown /> }
                    menuItemSelectedIcon={ <Check /> }
                    loading={ loading }
                    { ...props }
                >
                </AntSelect>

            );
    }
};


export { Select };
